import { render } from "./EventPageLayout.vue?vue&type=template&id=3732a39e"
import script from "./EventPageLayout.vue?vue&type=script&lang=js"
export * from "./EventPageLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__